import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from "../../hooks/useAuth";
import { usePasskeySignIn } from "../../hooks/usePasskeySignIn";
import { usePasskeySupport } from "../../hooks/usePasskeySupport";
/** 既定ボタンラベル。 */
const DEFAULT_LABEL = "パスキーでサインイン";
/** サインイン進行中ラベル。 */
const PENDING_LABEL = "サインイン中...";
/**
 * passkey サインインボタン。無効/検出中/非対応では `null`（silent degrade）。
 */
export function PasskeySignInButton({ onSuccess, onError, className, label = DEFAULT_LABEL, }) {
    const { passkeyEnabled } = useAuth();
    const { isChecking, webAuthnSupported } = usePasskeySupport();
    const { isPending, error, signIn } = usePasskeySignIn({
        ...(onSuccess !== undefined ? { onSuccess } : {}),
        ...(onError !== undefined ? { onError } : {}),
    });
    // passkey 無効 / 検出中 / 非対応では何も描画しない（silent degrade）。
    if (!passkeyEnabled || isChecking || !webAuthnSupported) {
        return null;
    }
    // 安定した class 名を付与し、消費アプリ側 CSS / E2E セレクタで参照可能にする
    // （`passkey-signin` / `passkey-signin-button` / `passkey-error`）。`className` は
    // ルート要素に追加する。CSS は本 lib では同梱せず、アプリが任意に提供する。
    const rootClassName = className ? `passkey-signin ${className}` : "passkey-signin";
    return (_jsxs("div", { className: rootClassName, "data-testid": "passkey-signin", children: [_jsx("button", { type: "button", className: "passkey-signin-button", onClick: () => {
                    void signIn();
                }, disabled: isPending, "aria-busy": isPending, children: isPending ? PENDING_LABEL : label }), error !== null && (_jsx("p", { className: "passkey-error", role: "alert", children: error }))] }));
}
